module.exports = __webpack_public_path__ + "static/img/model-user.010397c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/model-user.png
// module id = G6ms
// module chunks = 0